import styled from 'styled-components';
import { gap } from '../../../../juristec-ui/styles/theme';

export const Container = styled.div`
  height: 60vh;
  width: 70vw;
  margin: 5px 0px;
`;

export const Infos = styled.div`
  display: flex;
  padding: 5px;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px;
  ${gap('1.5rem', 'row')};
`;

export const StyledFont = styled.span`
  max-width: max-content;
  font-weight: 500;
  font-size: 16px;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.secondary};
`;

export const DashboardsCount = styled.div`
  display: flex;
  ${gap('3px', 'row')};
  font-size: 16px;
  max-height: 30px;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;

export const EmptyList = styled.div`
  background-color: ${({ theme }) => theme.containerOdd};
  width: 100%;
  text-align: center;
  padding: 10px 5px;
  color: ${({ theme }) => theme.color};
  font-size: 14px;
`;

export const DashboardText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & h4 {
    margin: 0;
  }
  & span {
    font-size: 14px;
  }
`;

export const TableOverFlow = styled.div`
  height: 50vh;
  overflow: auto;
  overflow-x: auto;
`;

export const Options = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${gap('5px', 'row')}
`;

export const BatchActions = styled.div`
  display: flex;
  ${gap('10px', 'row')}
`;
